<template>
    <div class="tutorial-viewer">
        <common-header left-div="blank" title="교안" right-div="close" v-on:closeEvent="closeEvent" />

        <div class="image-block">
            <img v-bind:src="courseInfo.tutorial_image_url" />
        </div>
    </div>
</template>

<script>
    import * as ajax from "../../utils/ajax";
    import CommonHeader from "../header/CommonHeader";

    export default {
    name: 'TutorialViewer',
        components: {CommonHeader},
        props: {
            courseNo: Number
        },
    data() {
        return {
            reply: "",
            courseInfo: {
                "tutorial_image_url": ""
            }
        }
    },
    methods: {
        closeEvent() {
            this.$emit("hideTutorial");
        }
    },
    watch: {
        'courseNo': function(val, oldVal) {
            ajax.Get(this, "/api/contents/course/" + val, function(ref, data) {
                ref.courseInfo = data;
            });
        }
    }
}
</script>

<style scoped lang="scss">
    div.tutorial-viewer {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: $seventh-color;
        z-index: 200;
    }

    div.image-block {
        padding: 18px;

        img {
            width: 100%;
            height: 100%;
        }
    }
</style>
